import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import { signOut } from '../../store/actions/authenticationActions'

const styles = (theme) => ({
    bar: {
        position: 'sticky',
        top: 0,
        zIndex: theme.zIndex.appBar,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        padding: theme.spacing(1.25, 3),
        background: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1, 2)
        }
    },
    logo: {
        height: 36,
        width: 'auto',
        display: 'block'
    },
    title: {
        fontWeight: 600,
        color: theme.palette.text.secondary,
        fontSize: '0.9rem',
        paddingLeft: theme.spacing(2),
        borderLeft: `1px solid ${theme.palette.divider}`,
        [theme.breakpoints.down('xs')]: {
            display: 'none'
        }
    },
    spacer: {
        flex: 1
    }
})

/**
 * The portal's header bar: Tanglewood logo, "My account", and Sign out for a
 * signed-in member.
 */
const AppHeader = ({ classes }) => {
    const dispatch = useDispatch()
    const isLoginTokenValid = useSelector(state => state.authentication.isLoginTokenValid)

    const logout = () => {
        dispatch(signOut(() => {
            window.location.reload()
        }))
    }

    return <header className={classes.bar}>
        <img className={classes.logo} src={`${process.env.PUBLIC_URL}/Tanglewood_Resort.png`} alt="Tanglewood Resort" />
        <span className={classes.title}>My account</span>
        <span className={classes.spacer} />
        {isLoginTokenValid && <Button variant="outlined" size="small" onClick={logout}>Sign out</Button>}
    </header>
}

export default withStyles(styles)(AppHeader)
